import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { DirectionProvider } from './DirectionProvider';
import Loading from './components/Loading';
import './components/Loading.css'

const Dashboard = lazy(() => import('./components/Dashboard'));
const KeyDetails = lazy(() => import( './components/KeyDetails'));
const MainLayout = lazy(() => import( './components/MainLayout'));
const SearchResults = lazy(() => import( './components/SearchResults'));
const StatsPage = lazy(() => import('./components/StatsPage'));
const UnderConstruction = lazy(() => import('./components/UnderConstruction'));
const EncryptMessage = lazy(() => import('./components/EncryptMessage'));
const GenerateKey = lazy(() => import('./components/GenerateKey'));

function App() {
  return (
    <Router basename={`/v2`}>
      <DirectionProvider>
        <main>
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route exact path="/" element={<Dashboard />} />
              <Route path="/stats" element={<StatsPage />} />
              <Route
                path="/search/:searchTerm"
                element={
                  <MainLayout>
                      <SearchResults />
                  </MainLayout>
                }
              />
              <Route
                path="/details/:keyId"
                element={
                  <MainLayout>
                    <KeyDetails />
                  </MainLayout>
                }
              />
              <Route path="/encrypt" element={<MainLayout><EncryptMessage /></MainLayout>} />
              <Route path="/decrypt" element={<MainLayout><UnderConstruction /></MainLayout>} />
              <Route path="/generate-keys" element={<MainLayout><GenerateKey /></MainLayout>} />
              <Route path="/import-keys" element={<MainLayout><UnderConstruction /></MainLayout>} />
              <Route path="/export-keys" element={<MainLayout><UnderConstruction /></MainLayout>} />
              <Route path="/sign" element={<MainLayout><UnderConstruction /></MainLayout>} />
              <Route path="/verify" element={<MainLayout><UnderConstruction /></MainLayout>} />
              <Route path="/about" element={<MainLayout><UnderConstruction /></MainLayout>} />
              <Route path="/contact" element={<MainLayout><UnderConstruction /></MainLayout>} />
            </Routes>
          </Suspense>
        </main>
      </DirectionProvider>
    </Router>
  );
}

export default App;
